// ABOUTME: Dynamic line chart icon for statistics/analytics
// ABOUTME: Supports className, size, and color customization

interface IconProps {
  className?: string
  size?: number
  color?: string
}

export const DynamicChartIcon = ({ className = "", size = 12, color = "#31B33A" }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M11.9062 10.375C11.9062 10.549 11.8371 10.716 11.714 10.839C11.591 10.9621 11.424 11.0312 11.25 11.0312H0.75C0.575952 11.0312 0.409032 10.9621 0.285961 10.839C0.16289 10.716 0.09375 10.549 0.09375 10.375V1.625C0.09375 1.45095 0.16289 1.28403 0.285961 1.16096C0.409032 1.03789 0.575952 0.96875 0.75 0.96875C0.924048 0.96875 1.09097 1.03789 1.21404 1.16096C1.33711 1.28403 1.40625 1.45095 1.40625 1.625V6.30352L3.81797 4.19531C3.93119 4.09625 4.07501 4.0391 4.22534 4.03343C4.37567 4.02775 4.52338 4.0739 4.64375 4.16414L7.71828 6.46977L10.818 3.75781C10.8815 3.69443 10.9573 3.64475 11.0408 3.61182C11.1242 3.5789 11.2135 3.56344 11.3032 3.5664C11.3929 3.56935 11.481 3.59067 11.5621 3.62902C11.6432 3.66737 11.7156 3.72194 11.7748 3.78937C11.834 3.8568 11.8787 3.93564 11.9062 4.02104C11.9337 4.10643 11.9434 4.19656 11.9347 4.28586C11.926 4.37516 11.8991 4.46172 11.8557 4.54021C11.8122 4.6187 11.7531 4.68744 11.682 4.74219L8.18203 7.80469C8.06881 7.90375 7.92499 7.9609 7.77466 7.96657C7.62433 7.97225 7.47662 7.9261 7.35625 7.83586L4.28172 5.53188L1.40625 8.04805V9.71875H11.25C11.424 9.71875 11.591 9.78789 11.714 9.91096C11.8371 10.034 11.9062 10.201 11.9062 10.375Z" />
  </svg>
)
